// Layout.tsx
import { useEffect } from 'react';
import { Layout, LayoutProps } from 'react-admin';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomSidebar from './CustomSidebar.tsx';
import CustomAppBar from './CustomAppBar.tsx';

const CustomLayout = (props: LayoutProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login', { replace: true });
      return;
    }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp && payload.exp * 1000 < Date.now()) {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('roleId');
        localStorage.removeItem('username');
        localStorage.removeItem('mustChangePassword');
        navigate('/login', { replace: true });
        return;
      }
    } catch {
      // Not a standard JWT — accept based on existence alone
    }

    // 首次登录（或管理员要求）必须先修改密码，强制拦截到修改密码页，直到修改完成
    const mustChangePassword = localStorage.getItem('mustChangePassword') === 'true';
    if (mustChangePassword && location.pathname !== '/change-password') {
      navigate('/change-password', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <Layout
      {...props}
      sidebar={CustomSidebar}
      appBar={CustomAppBar}
    />
  );
};

export default CustomLayout;
